import React, { useState, useEffect, useRef } from "react";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../Common/ShimmerLoader";
import { withTranslation } from "react-i18next";
import RouteMastersStore from "./store/useRouteMasterStore";
import AddRouteMasterModal from "./addRouteMasterModal";
import isGHMC from "../../Common/helper/helpar";
import DownloadExcel from "./exportExcel";
const RouteMaster = ({ t }) => {
  const isProd = isGHMC();
  const { fetchRouteMasters, routeMasterData ,loading} = RouteMastersStore()
  const headers = ["routeCode", "routeName", "zone", "ward", "routeSupervisorName", "status", "actions"]
  const [routeCode, setRouteCode] = useState('')
  const [selectedData, setSelectedData] = useState(null)
  const [lgShow, setLgShow] = useState(false)
  useEffect(() => {
    fetchRouteMasters(routeCode)
  }, [])

  const transformedData = routeMasterData.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
    routeSupervisorName: item.routeSuperVisorName || "N/A",
    zone: item.zoneName || "N/A",
    ward: item.circleName || "N/A"
  }));
  const searchRouteHandler = (e) => {
    setRouteCode(e.target.value)
  }

  const handleSearchClick = () => {
    setRouteCode(routeCode);
    fetchRouteMasters(routeCode); // Call API only when button clicked
  };

  const handleShow = () => {
    setLgShow(true)
    setSelectedData(null)
  }

  const handleEditRoute = (row) => {
    if (row && Object.keys(row).length > 0) {
      const cleanedRow = {
        ...row,
          routeSupervisorId:row.routeSupervisorID||null
      };
      setSelectedData(cleanedRow)
      setLgShow(true)
    }
  }
    return (
      <>
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <div className="page-header mb-0">
                <div className="row justify-content-between">
                  <div className="col-md-3">
                    <div className="d-flex align-items-end gap-2">
                      <input
                        placeholder="Search Route Code"
                        type="text"
                        className="form-control bg-white"
                        onChange={searchRouteHandler}
                        value={routeCode}
                      />
                      <button
                        type="button"
                        className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                        style={{ width: '100px' }}
                        onClick={handleSearchClick}
                      >
                        Search
                      </button>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="flex_end_middle mb-3">
                      {/* {canWriteValue === true ? */}
                      <button className="button-container"
                        onClick={handleShow}
                      >
                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                        {t("addRoute")}
                      </button>
                      {/* : ''} */}
                    <DownloadExcel data={transformedData} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="top-header">
                    <span >{t("Route")}</span>
                  </div>
                  <TableComponent isLoading={loading}
                    DataFetchURL={transformedData}
                    headers={headers}
                    editData={handleEditRoute}
                    filterFunction={(data) => data} // Show all data
                  />
                </div>
              </div>
              {lgShow ?
                <AddRouteMasterModal
                  showModal={lgShow}
                  setShow={setLgShow}
                  selectedData={selectedData}
                />
                : ""}
            </div>
          </div>
        </div>

      </>
    );
  };

  export default withTranslation()(RouteMaster);
